import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { StatusBadge, STATUSES } from "./StatusBadge";

const Field = ({ k, v }) => (
  <div className="border-b border-white/10 py-3">
    <p className="eyebrow">{k}</p>
    <p className="mt-1 whitespace-pre-wrap break-words text-sm text-zinc-100">{v || "—"}</p>
  </div>
);

export const BookingDetail = ({ booking, onClose, onStatus, onDelete }) => (
  <Dialog open={!!booking} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-h-[90vh] overflow-y-auto rounded-none border-white/10 bg-[#111317] text-zinc-100" data-testid="booking-detail-dialog">
      {booking && (
        <>
          <DialogHeader>
            <p className="eyebrow text-acid">{booking.reference}</p>
            <DialogTitle className="font-display text-3xl uppercase tracking-normal">{booking.name}</DialogTitle>
            <DialogDescription className="text-zinc-400">{booking.service_name}</DialogDescription>
          </DialogHeader>
          <div className="flex items-center gap-3"><StatusBadge status={booking.status} testid="detail-status-badge" />
            <span className="font-mono-x text-xs text-zinc-400">email: {booking.email_status}</span></div>
          <div className="grid sm:grid-cols-2 sm:gap-x-6">
            <Field k="Date" v={`${booking.date} · ${booking.time_label}`} />
            <Field k="Phone" v={booking.phone} />
            <Field k="Email" v={booking.email} />
            <Field k="Size" v={booking.property_size} />
          </div>
          <Field k="Address" v={booking.address} />
          <Field k="Notes" v={booking.notes} />
          <div className="flex flex-wrap gap-2 pt-2">
            {STATUSES.filter((s) => s !== booking.status).map((s) => (
              <button key={s} onClick={() => onStatus(booking, s)} data-testid={`detail-set-${s}-button`}
                className="rounded-full border border-white/15 px-4 py-2 text-sm font-semibold capitalize transition-colors hover:border-[var(--acid)] hover:text-[var(--acid)]">
                Mark {s}
              </button>
            ))}
            <button onClick={() => onDelete(booking)} data-testid="detail-delete-button"
              className="ml-auto rounded-full px-4 py-2 text-sm font-semibold text-red-400 transition-colors hover:bg-red-500/10">Delete</button>
          </div>
          <p className="text-xs text-zinc-400">Confirming or cancelling emails the customer automatically.</p>
        </>
      )}
    </DialogContent>
  </Dialog>
);
